import styled from 'styled-components';
import {  Segment } from 'semantic-ui-react';

// export const SemanticContainer = styled(Container)`
//   /* margin: 1em 0 0; */
// `;

export const Content = styled.div`
width: 100%;
padding: 1rem;
`;

export const Container = styled.div`
 width: 100%;
 padding-left: 250px;
`;

